import React from "react";

const items = [
    {
        title: "3D Event Layouts",
        body: "Spatial models showing the overall event environment, key features, guest flow, scale, sightlines and proportions.",
    },
    {
        title: "Proposal Visuals",
        body: "Rendered images designed to help sell a concept to clients, stakeholders or internal teams.",
    },
    {
        title: "Scenic & Set Visualisation",
        body: "Bespoke bars, backdrops, stages, entrances, branded moments, product displays, installations and photo opportunities.",
    },
    {
        title: "Venue Planning Visuals",
        body: "Models that test how a concept fits within a real venue — access, scale, layout, and practical use of space.",
    },
    {
        title: "Technical Support Drawings",
        body: "Plan views, elevations and working visuals to support supplier conversations, costing, fabrication and production planning.",
    },
    {
        title: "Pitch Support Assets",
        body: "Visual material designed to strengthen proposals, improve client understanding and give creative ideas more impact in presentations.",
    },
];

export default function WhatICreate() {
    return (
        <section
            id="what-i-create"
            data-testid="what-i-create-section"
            className="section-pad"
        >
            <div className="container-edge">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <h2
                        data-testid="what-i-create-heading"
                        className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-medium leading-[1.02] text-balance max-w-3xl"
                    >
                        Clear visuals for{" "}
                        <span className="italic font-normal text-champagne">
                            confident decisions.
                        </span>
                    </h2>
                    <p className="max-w-md text-foreground/70 text-[15px] leading-relaxed">
                        A flexible set of deliverables shaped around what your
                        project actually needs — from quick spatial models to
                        polished, client-ready visuals.
                    </p>
                </div>

                <ul className="mt-16 border-t border-border">
                    {items.map((c, i) => (
                        <li
                            key={c.title}
                            data-testid={`what-i-create-item-${i}`}
                            className="grid grid-cols-1 md:grid-cols-12 gap-4 py-7 md:py-9 border-b border-border"
                        >
                            <div className="md:col-span-5 font-display text-2xl md:text-3xl font-medium tracking-tight self-center">
                                {c.title}
                            </div>
                            <div className="md:col-span-7 text-foreground/75 text-[14.5px] leading-relaxed self-center">
                                {c.body}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
